module.exports = "/fonts/Simple-Line-Icons.woff2?0cb0b9c589c0624c9c78dd3d83e946f6";